import { render, staticRenderFns } from "./platformConfig.vue?vue&type=template&id=6e605ce0&"
import script from "./platformConfig.vue?vue&type=script&lang=js&"
export * from "./platformConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports